import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange, humanReadableLabels } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class AddLabel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
                selectedLabel: ''
            },
            labels: []
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        let form = {
            labels: paymentData?.labels ?? [],
        }

        let labels = [];
        if (humanReadableLabels && Object.keys(humanReadableLabels).length) {
            for (let key in humanReadableLabels) {
                labels.push({
                    value: key,
                    label: getHumanReadable(humanReadableLabels[key], this.props.lang)?.status
                })
            }
        }

        this.setState({ form, labels })
    }



    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();

        // this.checkIfExtendedPaymentManagementEnabled();
    }
    checkIfExtendedPaymentManagementEnabled = () => {
        const groupData = this.getGroupData();
        if (groupData?._id) {
            const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
            if (!EXTENDED_PAYMENT_MANAGEMENT) {
                this.onClose();
            }
        }
    }
    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {

    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }



    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }
        if (!form.selectedLabel) return;

        const data = {
            label: form.selectedLabel
        }

        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/add-label/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const status = paymentData?.currentStatus?.status.key;
        let errors = {};

        const selectedLabel = form?.selectedLabel !== -1 ? form?.selectedLabel : null;
        if (!selectedLabel) errors.selectedLabel = 'Label is required'.translate(this.props.lang);
        if (selectedLabel === 'refund_requested' && !['PAID', 'PARTIALLY_REFUNDED'].includes(status)) errors.selectedLabel = 'Payment must be either PAID or PARTIALLY REFUNDED to add a refund requested label'.translate(this.props.lang);

        return Object.keys(errors).length ? errors : null;
    }

    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const errors = this.state.errors ?? {};

        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Add label'.translate(this.props.lang)}

                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>

                            <Col lg='12'>
                                <FormGroup className={errors.selectedLabel ? 'fg-has-error' : ''}>
                                    <Label>{'Select label'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='select'
                                        value={this.state.form?.selectedLabel || -1}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!value) value = -1;
                                            let form = this.state.form;
                                            form.selectedLabel = value;
                                            let setObj = { form };
                                            if (this.state.errors?.selectedLabel) {
                                                let errors = this.state.errors;
                                                delete errors.selectedLabel;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    >
                                        <option value={-1}>{'Select label'.translate(this.props.lang)}</option>
                                        {
                                            this.state.labels.map((label) => {
                                                return <option value={label.value}>{label.label}</option>
                                            })
                                        }

                                    </Input>
                                    {errors.selectedLabel ? <div className='error-feedback'>{errors.selectedLabel}</div> : null}
                                </FormGroup>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate}
                        >
                            {'Save'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>



            </>
        );
    }
}


export default AddLabel;